module.exports = __webpack_public_path__ + "img/realizzazione 1.4973cf02.gif";